export default __webpack_public_path__ + "static/media/search1.f7ba6848.svg";